import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7026ef65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid kanban p-0" }
const _hoisted_2 = { class: "row kanban__row g-0" }
const _hoisted_3 = { class: "col-auto kanban__row__sidebar" }
const _hoisted_4 = { class: "col kanban__row__view" }
const _hoisted_5 = { class: "row g-0 flex-column kanban__row__view__row" }
const _hoisted_6 = { class: "col kanban__row__view__row__nav" }
const _hoisted_7 = { class: "col kanban__row__view__row__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kanban_sider_menu = _resolveComponent("kanban-sider-menu")!
  const _component_kanban_sider = _resolveComponent("kanban-sider")!
  const _component_kanban_navigation = _resolveComponent("kanban-navigation")!
  const _component_kanban_task_list_container = _resolveComponent("kanban-task-list-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_kanban_sider, {
          show: _ctx.siderState,
          onToggleSider: _ctx.toggleSider
        }, {
          default: _withCtx(() => [
            _createVNode(_component_kanban_sider_menu, {
              show: _ctx.siderState,
              onToggleSider: _ctx.toggleSider
            }, null, 8, ["show", "onToggleSider"])
          ]),
          _: 1
        }, 8, ["show", "onToggleSider"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_kanban_navigation)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_kanban_task_list_container)
          ])
        ])
      ])
    ])
  ]))
}